const logLevels = ['error', 'warn', 'log']
const prefix = 'Zmarta Experiments - '

function log (level = 'warn', message = '', obj = null) {
  if (logLevels.includes(level)) {
    console[level](prefix + message, obj || '')
  }
}

module.exports = {
  log
}
